




















import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { ConsultoresService } from "@/services/consultores.service";
import { date, dateTime, timeFromNow } from "@/shared/filters";

@Component({
  components: {
    DataTable,
  },
  filters: { date, dateTime, timeFromNow },
})
export default class Tickets extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  promiseTickets: Promise<any[]> | null = null;
  loading = false;
  selectRow = true;
  freshdesk = "";

  headersTickets = [
    { value: "dataCriacao", text: "Criado" },
    { value: "tipo", text: "Tipo" },
    { value: "assunto", text: "Assunto" },
    { value: "status", text: "Status" },
    { value: "analista", text: "Analista" },
  ];

  mounted() {
    this.fetchTickets(this.idConsultor);
  }

  async fetchTickets(idConsultor: number) {
    this.freshdesk = await ConsultoresService.ObterFreshdesk();
    this.loading = true;
    try {
      const consultor = await ConsultoresService.ObterDadosConsultor(
        idConsultor
      );
      this.promiseTickets = await ConsultoresService.Tickets(consultor.email);
    } finally {
      this.loading = false;
    }
  }

  async selecionadoAssunto(item: any) {
    window.open(this.freshdesk + "/helpdesk/tickets/" + item.id);
  }
}
